import { graphql, useStaticQuery } from "gatsby"

export default () => {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          siteUrl
          title
          shortTitle
          claim
          description
          lang
          canonicalUrl
          baseSite {
            url
            title
          }
          footerUrls {
            title
            url
          }
          social {
            twitter
            facebook
            instagram
          }
          facebookAppId
          googleMapsApiKey
          publisher {
            logoWidth
            name
          }
          color
        }
      }
    }
  `)
  return data.site.siteMetadata
}
